module.exports = __webpack_public_path__ + "static/shap_tecture-f23afa97c8d39307375db7dfa33cf15e.png";